// extracted by mini-css-extract-plugin
export default {"ad":"style_ad__ysnGR"};